(function () {
  'use strict';

  var id = "activity";
  angular.module('wsLrs.cards').factory(id + ".Leaderboard", [id + ".ActivityCardResource", function (ActivityCardResource) {
    return {
      createDefinition: function createDefinition(data, cardId, card) {
        //first massage the data
        angular.forEach(data.allAttempts.results, function (data) {
          data.scores = {
            "Recent": data.lastScore,
            "Best": data.bestScore,
            "First": data.firstScore
          };
        });
        var timelineCallback = function timelineCallback(leaderboardEntries) {
          var resource = new ActivityCardResource(cardId === "preview" ? card : null);
          return resource.timeline.get("", {
            params: {
              cardId: cardId,
              personIds: _.pluck(leaderboardEntries, "personId"),
              config: cardId === "preview" ? card.configuration : null
            }
          }).then(function (response) {
            return {
              data: response
            };
          });
        };
        var sortControls = [{
          "title": "People",
          "options": {
            "Last Name Ascending": "last",
            "Last Name Descending": "-last",
            "First Name Ascending": "name",
            "First Name Descending": "-name"
          }
        }, {
          "title": "Scores",
          "options": {
            "Best Score Ascending": "scores-best",
            "Best Score Descending": "-scores-best",
            "Last Score Ascending": "scores-last",
            "Last Score Descending": "-scores-last",
            "First Score Ascending": "scores-first",
            "First Score Descending": "-scores-first"
          }
        }, {
          "title": "Interaction History"
        }];
        if (card.configuration.surveyMode === true) {
          // Remove the scores header.
          sortControls.splice(1, 1);
        }
        return {
          index: 2,
          data: data,
          templateUrl: "modules/app/activity/leaderboard/interaction-leaderboard.html",
          sortControls: sortControls,
          timelineCallback: timelineCallback,
          timelineUniqueId: "personId",
          sortBy: "-scores-best",
          scoreType: "best",
          title: {
            text: "Leaderboard",
            main: true,
            emphasized: true
          },
          showScore: !card.configuration.surveyMode,
          getScoreSort: function getScoreSort(sortBy, scoreType) {
            return (sortBy.lastIndexOf('-', 0) === 0 ? '-' : '') + "scores-" + scoreType;
          },
          leaderboard: true
        };
      }
    };
  }]);
})();
